import { Navigate, Outlet } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { isAuthenticated, logoutUser } from 'utils/auth';

/* Protect dashboard routes */
export const ProtectedRoute = () => {
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    checkSession();
  }, []);

  const checkSession = async () => {
    if (!isAuthenticated()) {
      setChecking(false);
      return;
    }

    try {
      const res = await fetch(
        `${import.meta.env.VITE_API_URL}api/admin/auth/check`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
          }
        }
      );

      const result = await res.json();

      if (result?.Result === 0) {
        logoutUser();
        window.location.href = '/login';
        return;
      }

    } catch (error) {
      logoutUser();
      window.location.href = '/login';
      return;
    } finally {
      setChecking(false);
    }
  };

  if (checking) return null;

  return isAuthenticated() ? <Outlet /> : <Navigate to="/login" replace />;
};

/* Protect login route */
export const PublicRoute = () => {
  return isAuthenticated() ? <Navigate to="/dashboard" replace /> : <Outlet />;
};
